import React, { useEffect, useState } from 'react'
import http from '../Api';
import { useNavigate } from 'react-router-dom';

export default function Login() {
    const api = http();
    const navigate = useNavigate();
    const [input, setInput] = useState({
        login: "",
        password: ""
    });
    useEffect(() => {
        return () => {
        }
    }, [])

    return (
        <div>
            <div className="row">
                <div className="col-11 col-md-6 mx-auto shadow radios p-3">
                    <div className="row">
                        <div className="col-12">
                            <h4 className="text-center">
                                ورود به بخش پشتیبانی
                            </h4>
                        </div>
                        <div className="col-11 mx-auto">
                            <label htmlFor="">
                                نام کاربری
                            </label>
                            <input type="text" className="form-control"
                            maxLength={11}
                                value={input.phoneNumber}
                                onChange={(e) => setInput({ ...input, phoneNumber: e.target.value })}
                            />
                        </div>
                        <div className="col-11 mx-auto mt-2">
                            <label htmlFor="">
                                کلمه عبور
                            </label>
                            <input type="password" className="form-control"
                                value={input.password}
                                onChange={(e) => setInput({ ...input, password: e.target.value })}
                            />
                        </div>
                        <div className="col-6 mx-auto mt-3">
                            <button className="btn btn-success w-100" onClick={() => {
                                api.Login(({ data }) => {
                                    if (data.isSuccess) {
                                        localStorage.setItem("token", data.data);
                                        navigate("/");
                                    }
                                }, input);
                            }}  >
                                ورود
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
